module.exports = __webpack_public_path__ + "media/images/sns/line_icon-5280a5af3a038fb94f6b8e6461eaa63b.png";